import styled from 'styled-components';

// Общие стили для всех реестров юр.агента: договоры, контрагенты,
// претензии, корреспонденция, сроки. Сохраняем единый UX
// (поиск + фильтры + сортировка + пагинация) во всех таблицах.

export const RegistryToolbar = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 1fr) auto auto auto auto;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(3)};

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const RegistrySearchBox = styled.input`
  padding: 8px 12px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font: inherit;
  font-size: 13px;
  transition: border-color 160ms ease;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const RegistryFilterSelect = styled.select`
  padding: 8px 10px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  font: inherit;
  font-size: 13px;
  cursor: pointer;
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const RegistryBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(4)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const RegistryThSortable = styled.th<{ $active: boolean }>`
  cursor: pointer;
  user-select: none;
  color: ${({ theme, $active }) => ($active ? theme.colors.primary : 'inherit')};
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const RegistryEmpty = styled.td`
  text-align: center;
  padding: ${({ theme }) => theme.spacing(10)};
  color: ${({ theme }) => theme.colors.text.muted};
  font-size: 14px;
`;

export const RegistryPagination = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  padding: ${({ theme }) => theme.spacing(3)} 0;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const RegistryPageButtons = styled.div`
  display: inline-flex;
  gap: 6px;
`;

export const RegistryPageBtn = styled.button<{ $active?: boolean }>`
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border: 1px solid
    ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.border)};
  background: ${({ theme, $active }) => ($active ? theme.colors.primarySoft : 'transparent')};
  color: ${({ theme, $active }) => ($active ? theme.colors.primary : theme.colors.text.primary)};
  border-radius: ${({ theme }) => theme.radius.sm};
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  transition:
    background 160ms ease,
    border-color 160ms ease;
  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.surface};
  }
  &:disabled {
    cursor: default;
    opacity: 0.5;
  }
`;

/// компактная кнопка «Экспорт CSV» для размещения в RegistryBar.
/// Стилистически — outlined, чтобы не отвлекать от основной кнопки (например,
/// «+ Новый договор»), но при этом быть заметной как действие.
export const RegistryExportButton = styled.button<{ $disabled?: boolean }>`
  background: transparent;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.sm};
  padding: 4px 10px;
  font: inherit;
  font-size: 12px;
  color: inherit;
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  transition:
    background-color 120ms ease,
    border-color 120ms ease;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.surface};
    border-color: ${({ theme }) => theme.colors.primary};
    color: ${({ theme }) => theme.colors.primary};
  }
`;

/// Возвращает массив номеров страниц для компактного пагинатора:
/// первая, последняя, текущая и окно ±2 вокруг неё, с разрывами «…».
/// Если страниц мало (≤7) — показываем всё подряд.
export function paginationWindow(page: number, totalPages: number): number[] {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, i) => i);
  }
  const set = new Set<number>([0, totalPages - 1, page]);
  for (let d = 1; d <= 2; d++) {
    if (page - d >= 0) set.add(page - d);
    if (page + d < totalPages) set.add(page + d);
  }
  return Array.from(set).sort((a, b) => a - b);
}
